import * as actions from './settings-actions';
import * as mutations from './settings-mutations';
import { state } from './settings-state';

export const settings = {
  state,
  mutations,
  actions,
};
